export const GLOSSARY_ROOT_PATHS = {
  cs: '/slovnik-pojmu',
  en: '/glossary',
  pl: '/slownik-pojec'
};

export const SUPPORTED_GLOSSARY_LOCALES = Object.keys(GLOSSARY_ROOT_PATHS);

export function getGlossaryRootForLocale(locale) {
  return GLOSSARY_ROOT_PATHS[locale] || GLOSSARY_ROOT_PATHS.cs;
}

export function isGlossaryRoot(rootPath, locale) {
  return rootPath === getGlossaryRootForLocale(locale);
}

export function getGlossaryTermUrl(slug, locale) {
  const root = getGlossaryRootForLocale(locale);
  const prefix = locale === 'cs' ? '' : `/${locale}`;
  return `${prefix}${root}/${slug}`;
}

export function extractGlossaryTermSlug(restOfPath) {
  if (!restOfPath) return null;
  const trimmed = restOfPath.replace(/^\/+/, '').replace(/\/+$/, '');
  if (!trimmed) return null;
  const segments = trimmed.split('/');
  return segments[0] || null;
}
